import React from "react";
import Layout from "./Components/Layout";
import styles from "./styles/InnerPage.module.css";

export default function Directory() {
  // ✅ Add / edit these anytime
  const links = [
    {
      name: "Feng Shui Consultant PYFSC",
      url: "https://www.pyfsc.com",
      desc: "Feng Shui consultant",
      locale: "Sydney, Australia ",
      logo: "/feng-shui-consultant-Master-Philip-Yuen.png", // put logo in /public/images/partners/pyfsc.png
    },
    {
      name: "My Chinese Horoscope",
      url: "https://mychinesehoroscope.com",
      desc: "Chinese Zodiac finder, traits, elements, and compatibility resources.",
      locale: "Hong Kong China",
      logo: "/my-chinese-horoscope-finder.png", // you already have this
    },
    // Add more:
    // {
    //   name: "Example Partner",
    //   url: "https://example.com",
    //   desc: "Short description…",
    //   logo: "/images/partners/example.png",
    // },
  ];

  return (
    <Layout
      title="Explore Our Directory of Chinese Horoscope Resources - MyChineseHoroscope.com"
      description="Browse our curated directory of partner sites and resources for more insights into Chinese horoscopes, zodiac signs, astrology, and the five elements."
      keywords="chinese horoscope directory, partner sites, horoscope resources, zodiac insights, chinese zodiac partners, astrology resources, explore chinese astrology links"
      imageUrl="https://mychinesehoroscope.com/my-chinese-horoscope-finder.png"
      schemaData={{
        datePublished: "2025-08-05",
        authorName: "MyChineseHoroscope",
      }}
    >
      <div className={styles.page}>
        <div className={styles.container}>
          <header className={styles.hero}>
            <p className={styles.kicker}>MyChineseHoroscope.com</p>
            <h1 className={styles.h1}>Community Directory</h1>
            <p className={styles.sub}>
              A curated list of trusted friends, partners, and tools for Chinese Zodiac, Chinese Astrology, Feng Shui,
              and the Five Elements.
            </p>
          </header>

          <section className={styles.card}>
            <h2 className={styles.sectionTitle}>Featured links</h2>
            <p className={styles.p}>
              Explore these recommended resources to deepen your understanding and discover more helpful tools.
            </p>

            {/* ✅ Logo cards (no new CSS file) */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
                gap: 14,
                marginTop: 14,
              }}
            >
              {links.map((item) => (
                <a
                  key={item.url}
                  href={item.url}
                  title={item.name}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: "flex",
                    gap: 12,
                    alignItems: "center",
                    padding: 14,
                    borderRadius: 14,
                    border: "1px solid rgba(0,0,0,0.10)",
                    background: "rgba(255,255,255,0.92)",
                    textDecoration: "none",
                    color: "#111",
                  }}
                >
                  <div
                    style={{
                      width: 54,
                      height: 54,
                      borderRadius: 12,
                      overflow: "hidden",
                      border: "1px solid rgba(0,0,0,0.08)",
                      background: "#fff",
                      display: "grid",
                      placeItems: "center",
                      flex: "0 0 54px",
                    }}
                  >
                    {/* logo */}
                    <img
                      src={item.logo}
                      alt={item.name}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                      onError={(e) => {
                        // fallback if logo missing
                        e.currentTarget.style.display = "none";
                      }}
                    />
                  </div>

                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontWeight: 900, fontSize: 15, lineHeight: 1.2 }}>{item.name}</div>
                    <div style={{ marginTop: 6, fontSize: 13, opacity: 0.85, lineHeight: 1.35 }}>{item.desc}</div>
                    <div style={{ marginTop: 6, fontSize: 12, opacity: 0.85, lineHeight: 1.35 }}>{item.locale}</div>
              
                  </div>
                </a>
              ))}
            </div>
          </section>

          <section className={styles.card}>
            <h2 className={styles.sectionTitle}>Want to be listed?</h2>
            <p className={styles.p}>
              If you run a website related to Chinese Astrology, the Chinese Zodiac, <a href='https://pyfsc.com' title='Feng Shui'>Feng Shui</a>, or wellness and want to
              collaborate, contact us and we can feature your link on this page.
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
}

/* If you’re not using Next.js, you can delete this. Keeping it since you had it. */
export async function getStaticProps() {
  return {
    props: {},
    revalidate: 1,
  };
}